import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const useMultiLanguage = () => {
  const { t, i18n } = useTranslation();

  const getTranslations = useMemo(() => {
    const currentLang = i18n.language;
    const otherLangs = currentLang === 'it' ? ['pt', 'en'] : currentLang === 'pt' ? ['it', 'en'] : ['it', 'pt'];
    
    return (itemId, field) => {
      // Obtém a tradução no idioma atual
      const mainText = t(`menu.items.${itemId}.${field}`, { returnObjects: false });
      
      // Obtém as traduções nos outros idiomas sem alterar o estado
      const secondaryTexts = otherLangs.map(lang => {
        // Usa o método getFixedT para obter tradução sem alterar o idioma atual
        const fixedT = i18n.getFixedT(lang);
        const text = fixedT(`menu.items.${itemId}.${field}`, { returnObjects: false });
        return { text, lang };
      }).filter(item => item.text !== `menu.items.${itemId}.${field}`);
      
      return { mainText, secondaryTexts };
    };
  }, [t, i18n, i18n.language]);

  return { getTranslations };
};
